"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstablishedMethods = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const PreludeCard_1 = require("../prelude/PreludeCard");
const SelectCard_1 = require("../../inputs/SelectCard");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class EstablishedMethods extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.ESTABLISHED_METHODS,
            metadata: {
                cardNumber: 'X54',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(30).asterix();
                }),
                description: 'Gain 30 M€. Then immediately pay and perform 2 standard projects.',
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, 30);
        return EstablishedMethods.selectStandardProject(player, () => {
            player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                return EstablishedMethods.selectStandardProject(player, () => {
                    return undefined;
                });
            }));
            return undefined;
        });
    }
    static selectStandardProject(player, cb = () => undefined) {
        const availableStandardProjects = player.getStandardProjects()
            .filter((card) => card.canAct(player))
            .filter((card) => card.cost - card.discount(player) <= player.spendableMegacredits());
        if (availableStandardProjects.length === 0)
            return undefined;
        player.defer(new SelectCard_1.SelectCard('Select standard project to perform', 'Confirm', availableStandardProjects, (cards) => {
            cards[0].action(player);
            return cb();
        }), DeferredAction_1.Priority.DEFAULT);
        return undefined;
    }
}
exports.EstablishedMethods = EstablishedMethods;
//# sourceMappingURL=EstablishedMethods.js.map